import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Box,
  CircularProgress
} from '@material-ui/core'; 
import DeleteIcon from '@material-ui/icons/Delete'; 
import useAgentUrlCreate from 'api/useAgentUrlCreate';
import notifySuccess, { notifyFail } from 'utils/Toast';
import { ConfirmDeleteDialog } from '../List/ConfirmDeleteDialog';
import routes from 'routes';
import axios from 'axios';

const UrlManagerPopup = ({ open, onClose, setUrlDeleted, userAgentsUrl }) => {
  const { saveAgentsUrl, isLoading } = useAgentUrlCreate();
    const [confirm, setConfirm] = useState(false);
  const [newUrl, setNewUrl] = useState('');
  const [selectedUrl, setSelectedUrl] = useState('');

  const handleSave = async () => {
    // FIX: String comparison was wrong (newUrl.trim() === 0 will always be false)
    const trimmedUrl = newUrl.trim();
    if (!trimmedUrl) return;

    // Payload formatted as an array of objects as per your requirement
    const payload = [{
      url: trimmedUrl,
    }];

    try {
      const result = await saveAgentsUrl(payload);
      
      // Check for both 200 (OK) and 201 (Created) status codes
      if (result && (result.status === 200 || result.status === 201)) {
        notifySuccess(`Agents URL added successfully.`);
        
        // 1. Clear the input field
        setNewUrl('');
        
        // 2. Trigger parent GET API refresh using a unique timestamp
        // (If you just pass "false", the useEffect in the parent won't see a change)
        setUrlDeleted(`added-${Date.now()}`);
      }
    } catch (error) {
      console.error("Save failed:", error.response?.data || error.message);
    }
  };

  const handleDeleteClick = (rowData) => {
    setSelectedUrl(rowData);
    setConfirm(true);
  };

  const handleConfirmDelete = () => {
     handleDeleteURL(selectedUrl); 
    setConfirm(false);
    
  };
 const handleDeleteURL = async (id) => {
    console.log(id);
    const result = await axios.delete(
      `${routes.userAgent.endpoint}/deleteUserAgentUrl/${id}`,
    );
    if (result.status === 200) {
      setUrlDeleted(result);
      notifySuccess("URL is deleted Successfully.");
    } else {
      notifyFail("Failed to delete URL");
    }
    
  };
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>URL Manager</DialogTitle>
      
      <DialogContent dividers>
        <Box display="flex" gridGap={8} mb={3} alignItems="center">
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            label="Enter URL"
            placeholder="https://example.com"
            value={newUrl}
            onChange={(e) => setNewUrl(e.target.value)}
            disabled={isLoading}
            onKeyPress={(e) => {
              if (e.key === 'Enter') handleSave();
            }}
          />
          <Button 
            variant="contained" 
            color="primary" 
            onClick={handleSave}
            disabled={isLoading || !newUrl.trim()}
            style={{ height: '40px', minWidth: '80px' }}
          >
            {isLoading ? <CircularProgress size={20} color="inherit" /> : 'Add'}
          </Button>
        </Box>

        <TableContainer component={Paper} variant="outlined" style={{ maxHeight: 300 }}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell style={{ backgroundColor: '#f5f5f5', fontWeight: 'bold' }}>S.No</TableCell>
                <TableCell style={{ backgroundColor: '#f5f5f5', fontWeight: 'bold' }}>URL</TableCell>
                <TableCell align="right" style={{ backgroundColor: '#f5f5f5', fontWeight: 'bold' }}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {userAgentsUrl && userAgentsUrl.length > 0 ? (
                userAgentsUrl.map((item, index) => (
                  <TableRow key={item.id || index} hover>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell style={{ wordBreak: 'break-all' }}>
                      {/* Check if your API returns 'userAgent' or 'url' */}
                      <a 
                        href={item.userAgent || item.url} 
                        target="_blank" 
                        rel="noreferrer" 
                        style={{ color: '#1976d2', textDecoration: 'none' }}
                      >
                        {item.userAgent || item.url}
                      </a>
                    </TableCell>
                    <TableCell align="right">
                      <IconButton 
                        size="small" 
                        color="secondary" 
                        onClick={() => handleDeleteClick(item.id)}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={3} align="center" style={{ padding: '20px' }}>
                    No URLs found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="default">Close</Button>
      </DialogActions>
       <ConfirmDeleteDialog
              open={confirm}
              handleClose={() => setConfirm(false)}
              handleConfirm={handleConfirmDelete}
              agentName={""}
            />
    </Dialog>
    
  );
};

export default UrlManagerPopup;
